 // Truncate Text
 export const truncateText = (text, maxLength = 32) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;

    const startLength = Math.floor(maxLength / 2) - 2;
    const endLength = Math.floor(maxLength / 2) - 2;

    return `${text.substring(0, startLength)}...${text.substring(text.length - endLength)}`;
};